<template>
  <button class="button-vue">{{this.text}}</button>
</template>

<script>
export default{
  name:'ButtonVue',
  data(){
    return{

    }
  },
  props:{
    bgColor: String,
    text: String,
    color: String
  }
}
</script>

<style scoped lang='scss'>
.button-vue{
    padding: 10px 17px;
    border: none;
    border-radius: 20px;
    background-color: v-bind('bgColor');
    color: v-bind('color');
    cursor: pointer;
    font-size: 1.45rem;
    font-weight: 700;
}
</style>